import { Component, inject, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { ClarityService } from './shared/services/clarity.service';
import { MobileShellService } from './shared/services/mobile-shell.service';
import { OskGuideTopBarService } from './shared/services/osk-guide-top-bar.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit{
  title = 'prawko-management';

  private config = inject(PrimeNGConfig)
  private clarity = inject(ClarityService);
  private mobileShell = inject(MobileShellService);
  private oskGuideTopBar = inject(OskGuideTopBarService);

  ngOnInit() {
    this.clarity.start();
    this.mobileShell.start();
    this.oskGuideTopBar.start();
    this.config.setTranslation({
      dayNames: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],
      dayNamesShort: ["Nie", "Pn", "Wt", "Śr", "Czw", "Pt", "So"],
      dayNamesMin: ["N", "Pn", "Wt", "Śr", "Cz", "Pt", "So"],
      monthNames: ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"],
      monthNamesShort: ["Sty", "Lut", "Mar", "Kwi", "Maj", "Cze", "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"],
      dateFormat: "dd.mm.yy",
      firstDayOfWeek: 1,
      clear: "Wyczyść",
      today: "Dzisiaj",
      weekHeader: "Tydz.",
    });
  }
}
